import React, { useContext } from 'react';
import { Grid, Row, Col } from '@sm/wds-react';
import { LanguageMenuLI } from './LanguageMenu';
import { AuthedFooterLinks } from './FooterLinks';
import TrusteSeals from './TrusteSeals';
import CopyRight from './CopyRight';
import BillingAddress from './BillingAddress';
import { SMFooterContext } from './SMFooterContext';

const AuthedFooter = () => {
  const { domain, lang, country, showBillingAddress } = useContext(
    SMFooterContext
  );

  return (
    <div className="sm-footer">
      <Grid>
        <Row>
          <Col>
            <LanguageMenuLI lang={lang} />
          </Col>
        </Row>
        <Row>
          <Col md={7} className="wds-flex wds-flex--y-center">
            <div className="wds-flex__item">
              <AuthedFooterLinks domain={domain} lang={lang} />
              {showBillingAddress && <BillingAddress country={country} />}
              <CopyRight />
            </div>
          </Col>
          <Col md={5} className="wds-flex  wds-flex--y-center  wds-flex--x-end">
            <TrusteSeals />
          </Col>
        </Row>
      </Grid>
    </div>
  );
};

export default AuthedFooter;
